import { createFileRoute } from "@tanstack/react-router";
import { Debrief } from "@/features/logs";

/**
 * THE DEBRIEF — pushed from the timer when a piece ENDS, and never when one is discarded.
 *
 * ⚠️ THE HEADING MOVED INTO THE SCREEN (BUD-289) and the route no longer draws one. The
 * handoff's Screen 5 opens with "Nice work." and has no second title above it; a route that
 * kept printing "Debrief" would push the whole screen down to label something the sentence
 * already says. The route's job here is the id and nothing else.
 */
export const Route = createFileRoute("/_app/session/$id/debrief")({
  component: DebriefScreen,
});

function DebriefScreen() {
  const { id } = Route.useParams();

  /* 🔑 THIS ROUTE'S OWN ID, never "today's" session. On a two-a-day that is the other session
     entirely — the same rule the timer states when it pushes here. */
  return <Debrief sessionId={id} />;
}
